<footer class="d-block d-md-none" style="width:100%;">
  <section class="footer-menu">
    <div class="accordion p-4" id="accordionExample">
      <div class="text-center">
        <div id="headingOne">
          <h2 class="mb-0">
            <button class="btn  mdc-text-secondary w-100 text-left mdc-btn-acordeon" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              <b>Otras soluciones</b>
              <img src="assets/img/verifica/icon-add-foot.svg" alt="" class="mdc-icon-add-foot" id="headingOneIcon">
            </button>
          </h2>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body p-0">
            <ul class="mdc-ul-footer">
              @if (Bc) {
                <li><a target="_blank" [href]="linkDc">Buscacrédito</a></li>
              }
              <li>@if (sesionv.sesionCookiev) {
                <a routerLinkActive="active" routerLink="/private/antifraude">Antifraude</a>
              }</li>
              <li>@if (!sesionv.sesionCookiev) {
                <a routerLinkActive="active" routerLink="/plan-protegete" class="mdc-link-detail">Plan protégete</a>
              }</li>
              <li><a target="_blank" href="https://www.datacredito.com.co/">Canales gratuitos de consulta</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div id="headingTwo">
          <h2 class="mb-0">
            <button class="btn mdc-text-secondary  w-100 text-left mdc-btn-acordeon" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              <b>¿ Tienes dudas ?</b>
              <img src="assets/img/verifica/icon-add-foot.svg" alt="" class="mdc-icon-add-foot">
            </button>
          </h2>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div class="card-body p-0">
            <ul class="mdc-ul-footer">
              <li><a href="http://preguntas.midatacredito.com/" target="_blank" rel="noopener noreferrer">Preguntas frecuentes</a></li>
              <li><a routerLink="/contactanos">Contáctanos</a></li>
              <li><a target="_blank" href="http://www.sic.gov.co/">SIC</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div id="headingThree">
          <h2 class="mb-0">
            <button class="btn mdc-text-secondary collapsed  w-100 text-left mdc-btn-acordeon" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              <b>¿Quiénes sómos?</b>
              <img src="assets/img/verifica/icon-add-foot.svg" alt="" class="mdc-icon-add-foot">
            </button>
          </h2>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
          <div class="card-body p-0">
            <ul class="mdc-ul-footer">
              <li><a target="_blank" href="https://www.midatacredito.com/politicasdeprivacidad">Política de Privacidad</a></li>
              <li><a target="_blank" href="https://www.midatacredito.com/terminoscondiciones">Términos y condiciones</a></li>
              <li><a target="_blank" href="https://www.midatacredito.com/poliza" >Cláusulas póliza de seguro</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="footer-copy container-fluid">
    <div class="row">
      <div class="col-12 text-center py-3 pb-3 mb-4">
        <img src="assets/img/verifica/logo-copy.svg" class="mdc-logo-f mb-3" alt="">
        <p style="color:#fff;"> <i class="fa fa-map-marker"></i> Carrera 7 # 76 -35 - ©2019 Experian Information Solutions, Inc. Derechos reservados </p>
      </div>
    </div>
  </section>
</footer>
<footer class="d-md-block d-none">
  <section class="footer-menu py-5">
    <div class="container">
      <div class="row">
        <div class="col-3 my-auto">
          @if (!sesionv.sesionCookiev) {
            <img routerLink="/" src="assets/img/verifica/logo_midc.svg" class="img-fluid mx-auto mdc-link-detail" alt="">
          }
          @if (sesionv.sesionCookiev) {
            <img routerLink="/private" src="assets/img/verifica/logo_midc.svg" class="img-fluid mx-auto mdc-link-detail" alt="">
          }
        </div>
        <div class="col-3">
          <ul class="mdc-ul-footer">
            <li class="mdc-text-secondary">Otras soluciones</li>
            @if (Bc) {
              <li><a [href]="linkDc" target="_blank">Buscacrédito</a></li>
            }
            <li>@if (sesionv.sesionCookiev) {
              <a routerLinkActive="active" routerLink="/private/antifraude">Antifraude</a>
            }</li>
            <li>@if (!sesionv.sesionCookiev) {
              <a class="mdc-link-detail">Antifraude</a>
            }</li>
            <li><a target="_blank" href="https://www.datacredito.com.co/">Canales gratuitos de consulta</a></li>
          </ul>
        </div>
        <div class="col-3">
          <ul class="mdc-ul-footer">
            <li class="mdc-text-secondary">¿Tienes dudas?</li>
            <li><a href="http://preguntas.midatacredito.com/" target="_blank" rel="noopener noreferrer">Preguntas frecuentes</a></li>
            <li><a routerLink="/contactanos">Contáctanos</a></li>
            <li><a target="_blank" href="http://www.sic.gov.co/">SIC</a></li>
          </ul>
        </div>
        <div class="col-3">
          <ul class="mdc-ul-footer">
            <li class="mdc-text-secondary">¿Quiénes sómos?</li>
            <li><a target="_blank" href="https://www.midatacredito.com/politicasdeprivacidad">Política de Privacidad</a></li>
            <li><a target="_blank" href="https://www.midatacredito.com/terminoscondiciones">Términos y condiciones</a></li>
            <li><a target="_blank" href="https://www.midatacredito.com/poliza">Cláusulas póliza de seguro</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="footer-copy container-fluid">
    <div class="row">
      <div class="col-12 text-center py-5">
        <img src="assets/img/verifica/logo-copy.svg" class="mdc-logo-f mb-3" alt="" width="288">
        <p style="color:#fff;"> <i class="fa fa-map-marker mdc-text-3 mr-2"></i> Carrera 7 # 76 -35 - ©2019 Experian Information Solutions, Inc. Derechos reservados </p>
      </div>
    </div>
  </section>
  <p class="version">
    V.a13-0.2
  </p>
</footer>